module.exports = function (ErrorsActions) {
   return function globalHandler(args) {
      ErrorsActions.error(args);
   };
};
